export function makeDate(date, format = 1) {
	let months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']
	let _date = null;
	if (format == 6) {
		//Ay ismine karşılık ay indeksini verir
		_date = parseInt(months.indexOf(date)+1)
		
		if(_date <10)
		{
			
			return "0"+_date.toString();
		}
		else
		{
			
			return _date.toString();
		}
			
		
		
	}


	let d = new Date(date);







	if (format == 4) {
		var TarihBol = date.toString().split('-');
		var SaatBol = TarihBol[2].split(' ');
		var DakikaBol = SaatBol[1].split(':')

	}


	let day = d.getDate();
	let month = d.getMonth();
	let year = d.getFullYear();


	

	if (format == 1) _date = `${day < 10 ? '0' + day : day} ${months[month]} ${year}`
	//13 Ekim 2020
	if (format == 2) _date = `${day < 10 ? '0' + day : day}.${month + 1 < 10 ? '0' + (month + 1) : (month + 1)}.${year}`
	//13.10.2020
	if (format == 3) _date = `${year}-${month + 1 < 10 ? '0' + (month + 1) : (month + 1)}-${day < 10 ? '0' + day : day}`
	//2022-10-13
	if (format == 4) _date = `${TarihBol[0]} ${months[parseInt(TarihBol[1] - 1)]} ${SaatBol[0]} ${DakikaBol[0]}:${DakikaBol[1]}`

	if (format == 5) _date = `${months[month]}`
	//Ocak


	return _date
}